import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const ontimeeldConfig: TSPConfig = {
  key: 'ontimeeld',
  name: 'OnTimeELD',
  imageName: 'OnTimeELD',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>
        To connect your OnTimeELD account, you'll need the following
        credentials:
      </p>
      <ol>
        <li>x-access-token (Authorization Code)</li>
        <li>provider-token (API Key)</li>
        <li>US DOT Number</li>
      </ol>
      <p>
        Please contact your OnTimeELD administrator if you need help finding
        these credentials.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'x-access-token',
          name: 'apikey',
          type: 'text',
          required: true,
        },
        {
          label: 'provider-token',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
        {
          label: 'US DOT Number',
          name: 'dotnumber',
          type: 'number',
          required: true,
        },
      ]}
    />
  ),
};

export default ontimeeldConfig;
